import * as Yup from 'yup';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useSkillsFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();

  const formSchema = Yup.object().shape({
    skills: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSearchChange = (currentValue) =>
    getFilterOptions({
      facet: 'skills',
      query: currentValue,
      sharedList,
      orderBy,
    }).then((res) => res.data);

  const onSubmit = ({ skills }) => {
    setFilters({ skills });
  };

  return {
    formSchema,
    onSearchChange,
    onSubmit,
  };
};
